import * as Config from '../../../config';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './DNav.css';

import DNavCharts from './DNavCharts';
import DNavPlaylists from './DNavPlaylists';
import DNavReleases from './DNavReleases';

import { connect } from "react-redux";
import { closeDManager } from "../../../actions/index";

// Entrypoint for the coverflow carrousel horizontal
function ConnectedDNavManager({ width, DManager, storeHistory, closeDManager }) {
  const { toggle, pathApi, type } = DManager;

  const componentTypes = {
    'CHART': DNavCharts,
    'PLAYLIST': DNavPlaylists,
    'RELEASE': DNavReleases,
  };

  let open = false;
  if (storeHistory && storeHistory.history) {
    const h = storeHistory.history.find( x => x.active );

    open = (h && type) ? (h.path.includes(type.toLowerCase())) : false;
    if (!open && toggle) {
      closeDManager();
    }
  }

  useEffect(() => {
    if (storeHistory && storeHistory.history) {
      const h = storeHistory.history.find( x => x.active );
      if (type === `RELEASE` && h && h.path && h.path.includes(`genres`)) {
        closeDManager();
      }
    }
  }, [storeHistory, type, closeDManager])

  return (pathApi && open) ? (
    <div className={`Dnav`} style={{ display: (toggle && pathApi) ? `block` : `none` }}>
      { React.createElement(componentTypes[type], {
        id: `dnav_${type}`, pathApi, width, height: Config.DNAV_COVER_SIZE + Config.GRID_COVER_PAD * 2,
        rowCount: 1, rowWidth: Config.DNAV_COVER_SIZE, rowHeight: Config.DNAV_COVER_SIZE + Config.GRID_COVER_PAD,
        style: { display: (toggle && pathApi) ? `block` : `none` }
      })}
    </div>
  ) : null
}

ConnectedDNavManager.propTypes = {
  width: PropTypes.any
}

const DNavManager = connect(
  state => ({
    width: state.dimension.width,
    DManager: state.DManager,
    storeHistory: state.storeHistory
  }),
  dispatch => ({
    closeDManager: () => dispatch(closeDManager())
  })
)(ConnectedDNavManager);

export default DNavManager;
